// extracted by mini-css-extract-plugin
module.exports =  {"warning":"a1k6VyW9AKxSjAPmrf_w"};